import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PortfolioCategoryActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/PortfolioCategory/PortfolioCategoryBrowser")
	}

	render() {
		return (
			<Activity 
				name="PortfolioCategory"
				RenderedComponent={this.RenderedComponent}
                context="PortfolioCategory"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PortfolioCategoryActivity)